export function getVehicleStatus(vehicle) {
  if (vehicle.isInside === false) return "FUERA";
  if (vehicle.isInside !== true) return "SIN INFORMACIÓN";
  if (vehicle.parkingType === "vip") return "EN VIP";
  if (vehicle.parkingType === "general") return "EN GENERAL";
  const active = (entry, exit) => {
    const start = Date.parse(entry);
    const end = Date.parse(exit);
    return Number.isFinite(start) && (!Number.isFinite(end) || end <= start);
  };
  if (active(vehicle.ent_vip, vehicle.sal_vip)) return "EN VIP";
  if (active(vehicle.ent_gen, vehicle.sal_gen)) return "EN GENERAL";
  return "DENTRO";
}
export function filterVipVehicles(vehicles, search, status = "TODOS") {
  const query = search.trim().toLocaleLowerCase("es");
  const rank = { "EN VIP": 0, "EN GENERAL": 1, DENTRO: 2, FUERA: 3, "SIN INFORMACIÓN": 4 };
  return vehicles
    .filter((vehicle) => {
      const state = getVehicleStatus(vehicle);
      return (
        (status === "TODOS" || state === status) &&
        (!query ||
          [
            vehicle.idvehicle,
            vehicle.plate,
            vehicle.groupName,
            vehicle.tid,
            vehicle.ent_gen,
            vehicle.sal_gen,
            vehicle.ent_vip,
            vehicle.sal_vip,
            vehicle.enterat,
            state,
          ].some((value) =>
            String(value ?? "")
              .toLocaleLowerCase("es")
              .includes(query)
          ))
      );
    })
    .sort((a, b) => rank[getVehicleStatus(a)] - rank[getVehicleStatus(b)]);
}
